import React, {Component} from 'react';
import EndPoint from "./rest";
import swal from "sweetalert2";
import "./Login.css";
import Loading from "./components/loading";

export default class Login extends Component {
	constructor () {
		super();
		this.state = {
			email: "",
			password: "",
			fetching: false
		}
		this.login = this.login.bind(this);
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
	}

	login (e) {
		e.preventDefault();
		this.setState({fetching: true});
		EndPoint.API.post("/login", {email: this.state.email, password: this.state.password})
		.then(response => {
			EndPoint.setToken(response.headers.authorization);
			this.context.router.push("/calendar");
		})
		.catch((error)=> {
			if (error.response) {
				if (error.response.status === 401) {
					swal({
						title: 'Error',
						text: "Las credenciales no coincide con ningun registro",
						type: 'error'
					});
				} else {
					swal({
						title: 'Error',
						text: `Status: ${error.response.status}\nMessage: ${error.response.statusText}`,
						type: 'error'
					});
				}
			} else {
				swal({
					title: 'Error',
					text: error.message,
					type: 'error'
				});
				console.error(error);
			}
			this.setState({password: ""});
		}).then(()=>{
			this.setState({fetching: false});
		})
	}
	handleEmailChange ({target: {value}}) {
		this.setState({email: value});
	}
	handlePasswordChange ({target: {value}}) {
		this.setState({password: value});
	}
	render() {
		return (
			<div className="row align-center align-middle" style={{height: "100vh"}}>
				<Loading loading={this.state.fetching}/>
				<form className="row small-10 medium-7 large-4" onSubmit={this.login}>
					<label className="columns small-12">
						<em>Correo</em>
						<input autoFocus type="email" placeholder="example@domain.tld" value={this.state.email} onChange={this.handleEmailChange} required/>
					</label>
					<label className="columns small-12">
						<em>Contraseña</em>
						<input type="password" value={this.state.password} onChange={this.handlePasswordChange} required/>
					</label>
					<label className="columns small-12">
						<em> </em>
						<button type="submit" className="button expanded success">Acceder</button>
					</label>
				</form>
			</div>
		);
	}
}

Login.contextTypes =  {
	router: React.PropTypes.object.isRequired
};


/** WEBPACK FOOTER **
 ** ./src/Login.js
 **/